export class CookieUtils {
  static setCookie(name, value, expires, path, domain, secure) {
    var cookieText =
      // encodeURIComponent(name) + '=' + encodeURIComponent(value)
      name + '=' + value
    if (expires instanceof Date) {
      cookieText += '; expires=' + expires.toGMTString()
    }
    if (path) {
      cookieText += '; path=' + path
    }
    if (domain) {
      cookieText += '; domain=' + domain
    }
    if (secure) {
      cookieText += '; secure'
    }
    document.cookie = cookieText
  }
  static getCookie(name) {
		let cookieName = encodeURIComponent(name) + '=',
			cookieStart = document.cookie.indexOf(cookieName),
			cookieValue = null
		if (cookieStart > -1) {
			let cookieEnd = document.cookie.indexOf(';', cookieStart)
			if (cookieEnd == -1) {
				cookieEnd = document.cookie.length
			}
			cookieValue = decodeURIComponent(
				document.cookie.substring(cookieStart + cookieName.length, cookieEnd)
			)
		}
		return cookieValue
	}
}